import React from 'react'
import useLangTranslation from '../../customHooks/languageProvider';
import { Link } from 'react-router-dom';

const AuthTermsService = () => {
    const { getLangTranslation } = useLangTranslation();
    return (
        <p className="text-center fw-semibold">
            {getLangTranslation('SIGNUP_BY_SIGNING_UP', 'By signing up, you agree with the')}
            <a href="https://www.kidoprotect.com/terms-and-conditions/" className="ms-1">{getLangTranslation('SIGNUP_TERMS_AND_SERVICES', 'Terms of Service')}</a>
            {' '}
            {getLangTranslation('SIGNUP_AND', 'and')}
            {' '}
            <a href="https://www.kidoprotect.com/privacy-policy/"> {getLangTranslation('SIGNUP_PRIVACY_POLICY', 'Privacy Policy')}</a>
        </p>
    )
}

export default AuthTermsService